var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-main",
    { staticClass: "pa-2 report_detail", attrs: { fluid: "" } },
    [
      _c("h1", [_vm._v("Daily Report")]),
      _vm._v(" "),
      _c(
        "section",
        [
          _c(
            "v-row",
            [
              _vm.checkGate("sales-access")
                ? _c(
                    "v-col",
                    { attrs: { cols: "12", md: "4" } },
                    [
                      _c("v-subheader", [_vm._v("Notes")]),
                      _vm._v(" "),
                      _vm.currentDateSales
                        ? _c("p", [_vm._v(_vm._s(_vm.currentDateSales.report))])
                        : _vm._e(),
                      _vm._v(" "),
                      _c("v-subheader", [_vm._v("From day before")]),
                      _vm._v(" "),
                      _vm.prevDateSales
                        ? _c("p", [_vm._v(_vm._s(_vm.prevDateSales.report))])
                        : _vm._e()
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "v-col",
                { attrs: { cols: "12", md: "8" } },
                [
                  _c("v-subheader", [_vm._v("Day Status")]),
                  _vm._v(" "),
                  _c("v-data-table", {
                    staticClass: "no-footer-table",
                    attrs: { headers: _vm.countsHeaders, items: _vm.dayTotals }
                  })
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      _vm.checkGate("sales-access")
        ? _c("DailySales", {
            on: {
              logSales: _vm.openDialog,
              editSalesReport: _vm.edit,
              bankTotalInSafe: _vm.bank
            }
          })
        : _vm._e(),
      _vm._v(" "),
      _c("Staff"),
      _vm._v(" "),
      _vm.checkGate("aircrafts-log-mgmt") ? _c("AircraftLogs") : _vm._e(),
      _vm._v(" "),
      _vm.checkGate("packing-jobs-mgmt") ? _c("PackingJobs") : _vm._e(),
      _vm._v(" "),
      _c("DayPicker", { on: { reloadData: _vm.loadData } }),
      _vm._v(" "),
      _vm.checkGate("sales-access")
        ? _c(
            "v-dialog",
            {
              attrs: { persistent: "", "max-width": "600px" },
              on: {
                keydown: function($event) {
                  if (
                    !$event.type.indexOf("key") &&
                    _vm._k($event.keyCode, "esc", 27, $event.key, [
                      "Esc",
                      "Escape"
                    ])
                  ) {
                    return null
                  }
                  _vm.dialog = false
                }
              },
              model: {
                value: _vm.dialog,
                callback: function($$v) {
                  _vm.dialog = $$v
                },
                expression: "dialog"
              }
            },
            [
              _c(
                "v-form",
                {
                  on: {
                    submit: function($event) {
                      $event.preventDefault()
                      return _vm.save($event)
                    }
                  },
                  model: {
                    value: _vm.valid,
                    callback: function($$v) {
                      _vm.valid = $$v
                    },
                    expression: "valid"
                  }
                },
                [
                  _c(
                    "v-card",
                    [
                      _c(
                        "v-card-text",
                        [
                          _c(
                            "fieldset",
                            { staticClass: "inline-form input-6" },
                            [
                              _c("legend", [
                                _vm._v("Cash : $" + _vm._s(_vm.cashTotal))
                              ]),
                              _vm._v(" "),
                              _c("v-text-field", {
                                ref: "ones",
                                attrs: { label: "$1", type: "number" },
                                model: {
                                  value: _vm.editedItem.ones,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editedItem, "ones", $$v)
                                  },
                                  expression: "editedItem.ones"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                ref: "fives",
                                attrs: { label: "$5", type: "number" },
                                model: {
                                  value: _vm.editedItem.fives,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editedItem, "fives", $$v)
                                  },
                                  expression: "editedItem.fives"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                ref: "tens",
                                attrs: { label: "$10", type: "number" },
                                model: {
                                  value: _vm.editedItem.tens,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editedItem, "tens", $$v)
                                  },
                                  expression: "editedItem.tens"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                ref: "twenties",
                                attrs: { label: "$20", type: "number" },
                                model: {
                                  value: _vm.editedItem.twenties,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editedItem, "twenties", $$v)
                                  },
                                  expression: "editedItem.twenties"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                ref: "fifties",
                                attrs: { label: "$50", type: "number" },
                                model: {
                                  value: _vm.editedItem.fifties,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editedItem, "fifties", $$v)
                                  },
                                  expression: "editedItem.fifties"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                ref: "hundreds",
                                attrs: { label: "$100", type: "number" },
                                model: {
                                  value: _vm.editedItem.hundreds,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editedItem, "hundreds", $$v)
                                  },
                                  expression: "editedItem.hundreds"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "fieldset",
                            { staticClass: "inline-form input-4" },
                            [
                              _c("v-text-field", {
                                attrs: {
                                  prefix: "$",
                                  readonly: "",
                                  type: "number",
                                  label: "Cash on Hand"
                                },
                                model: {
                                  value: _vm.onHand,
                                  callback: function($$v) {
                                    _vm.onHand = $$v
                                  },
                                  expression: "onHand"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  prefix: "$",
                                  readonly: "",
                                  type: "number",
                                  label: "Cash Discrepancy"
                                },
                                model: {
                                  value: _vm.cashDiscrepancy,
                                  callback: function($$v) {
                                    _vm.cashDiscrepancy = $$v
                                  },
                                  expression: "cashDiscrepancy"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  prefix: "$",
                                  type: "number",
                                  label: "Cash Deposited"
                                },
                                model: {
                                  value: _vm.editedItem.deposited,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editedItem, "deposited", $$v)
                                  },
                                  expression: "editedItem.deposited"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  readonly: "",
                                  prefix: "$",
                                  type: "number",
                                  label: "Tomorrow Start"
                                },
                                model: {
                                  value: _vm.tomoStart,
                                  callback: function($$v) {
                                    _vm.tomoStart = $$v
                                  },
                                  expression: "tomoStart"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: { label: "Reason for Discrepancy" },
                            model: {
                              value: _vm.editedItem.cashNotes,
                              callback: function($$v) {
                                _vm.$set(_vm.editedItem, "cashNotes", $$v)
                              },
                              expression: "editedItem.cashNotes"
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "fieldset",
                            { staticClass: "inline-form input-3" },
                            [
                              _c("legend", [_vm._v("Credit Card")]),
                              _vm._v(" "),
                              _vm.calculatedDailySales
                                ? _c("v-text-field", {
                                    attrs: {
                                      readonly: "",
                                      prefix: "$",
                                      type: "number",
                                      label: "Calculated"
                                    },
                                    model: {
                                      value: _vm.calculatedDailySales.ccSales,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.calculatedDailySales,
                                          "ccSales",
                                          $$v
                                        )
                                      },
                                      expression: "calculatedDailySales.ccSales"
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  prefix: "$",
                                  type: "number",
                                  label: "CC Terminal"
                                },
                                model: {
                                  value: _vm.editedItem.ccTerminal,
                                  callback: function($$v) {
                                    _vm.$set(_vm.editedItem, "ccTerminal", $$v)
                                  },
                                  expression: "editedItem.ccTerminal"
                                }
                              }),
                              _vm._v(" "),
                              _c("v-text-field", {
                                attrs: {
                                  prefix: "$",
                                  readonly: "",
                                  type: "number",
                                  label: "CC Discrepancy"
                                },
                                model: {
                                  value: _vm.ccDiscrepancy,
                                  callback: function($$v) {
                                    _vm.ccDiscrepancy = $$v
                                  },
                                  expression: "ccDiscrepancy"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: { label: "Reason for Discrepancy" },
                            model: {
                              value: _vm.editedItem.ccNotes,
                              callback: function($$v) {
                                _vm.$set(_vm.editedItem, "ccNotes", $$v)
                              },
                              expression: "editedItem.ccNotes"
                            }
                          }),
                          _vm._v(" "),
                          _c("hr"),
                          _vm._v(" "),
                          _c("v-text-field", {
                            attrs: { label: "Notes" },
                            model: {
                              value: _vm.editedItem.report,
                              callback: function($$v) {
                                _vm.$set(_vm.editedItem, "report", $$v)
                              },
                              expression: "editedItem.report"
                            }
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-card-actions",
                        [
                          _c("v-spacer"),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: { color: "blue darken-1", text: "" },
                              on: { click: _vm.close }
                            },
                            [_vm._v("Cancel")]
                          ),
                          _vm._v(" "),
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                color: "blue darken-1",
                                type: "submit",
                                disabled: !_vm.valid
                              }
                            },
                            [_vm._v("Save")]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }